import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'ca-rerun-workflow-step-button',
    templateUrl: './rerun-workflow-step-button.component.html',
})
export class RerunWorkflowStepButtonComponent {
    @Input() isStepByStepRun: boolean = false;
    @Input() isActiveInStepByStep: boolean = false;
    @Input() didParametersChange: boolean = false;
    @Input() isDisabled: boolean = true;
    @Input() isFormValid: boolean = true;
    @Output() onReRunButtonClick: EventEmitter<void> = new EventEmitter<void>();
}
